/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type AllCommentsTabContainerLocal = {
    readonly ratingFilter: number | null;
    readonly commentsOrderBy: COMMENT_SORT;
    readonly " $refType": "AllCommentsTabContainerLocal";
};
export type AllCommentsTabContainerLocal$data = AllCommentsTabContainerLocal;
export type AllCommentsTabContainerLocal$key = {
    readonly " $data"?: AllCommentsTabContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"AllCommentsTabContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AllCommentsTabContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ratingFilter",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentsOrderBy",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = '06796f5714310da19d3f6926bd3a3da5';
export default node;
